// @ts-nocheck
/*
 * Cyber oct 2026: el motor de la oferta. Todas las partes de la web que muestran el Cyber leen de acá,
 * así que un cambio se hace en un solo lugar.
 *
 * Cómo decide qué mostrar:
 * - Las fechas van fijas (hora de Chile): pre del jue 1 a las 21:00 al dom 4, núcleo del lun 5 al mié 7, post del
 *   jue 8 al dom 11. Todo aparece solo el jue 1 a las 21:00 y se apaga solo el lun 12 a las 00:00.
 * - Lo que cambia durante el evento son los interruptores de Configuración del tema → Cyber oct 2026
 *   (llegan en window.EP_CYBER_CFG desde snippets/ep-cyber.liquid): regalo, cada sabor, Mercado Pago
 *   y los $5.000.
 * - El reloj es el del navegador, para que el cambio de tramo a medianoche se vea al tiro aunque la
 *   página venga de la caché de Shopify.
 *
 * Qué pinta:
 * - [data-cy="on|off|regalo|d5|mp|!regalo..."] se muestra o se esconde según el estado.
 * - [data-cy-comp="barra|hero|ticket|mq"] se rellena con la pieza aprobada.
 * - [data-cd] es la cuenta regresiva.
 *
 * Para probar (solo en un tema sin publicar, nunca en la tienda): ?cyber_ahora=2026-10-05T10:00,
 * ?cyber_regalo=0, ?cyber_d5=1, ?cyber_mp=0, ?cyber_sabores=caramelo,mani y ?cyber_prueba=off para
 * volver al reloj real. Se guardan en la sesión del navegador.
 */
(function () {
  'use strict';

  var CFG = window.EP_CYBER_CFG || {};
  var T = {
    inicio: Date.parse('2026-10-01T21:00:00-03:00'), // Tomi, 1-oct: parte con la publicación, el jue 1 a las 21:00
    nucleo: Date.parse('2026-10-05T00:00:00-03:00'),
    post: Date.parse('2026-10-08T00:00:00-03:00'),
    ultimo: Date.parse('2026-10-11T00:00:00-03:00'),
    // Urgencia por día en la franja que corre (Tomi, 7-oct): mié 7 "Último día", jue 8 y vie 9 "Últimos
    // regalos", sáb 10 y dom 11 "Lo alargamos: solo hasta el domingo".
    urgDia: Date.parse('2026-10-07T00:00:00-03:00'),
    urgAlarga: Date.parse('2026-10-10T00:00:00-03:00'),
    fin: Date.parse('2026-10-12T00:00:00-03:00'),
  };
  // Orden del selector del regalo: el primero es el que entra solo al carro. Tomi, 8-oct: de más a
  // menos cupo libre (Caramelo 34, Choc. Blanco 26, Cacao 4; Maní apagado). Antes, 5-oct: Choc. Blanco
  // primero; 1-oct: Caramelo primero.
  var SABORES = [
    { key: 'caramelo', nombre: 'Caramelo' },
    { key: 'choc_blanco', nombre: 'Chocolate Blanco' },
    { key: 'cacao', nombre: 'Cacao' },
    { key: 'mani', nombre: 'Maní' },
  ];
  var PACKS_URL = '/collections/todos-los-packs';
  var PLUS = '<span class="epcy-plus" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14" stroke="#fff" stroke-width="3.4" stroke-linecap="round"/></svg></span>';

  // ── Modo prueba: solo fuera del tema publicado ─────────────────────────────
  function enPreview() {
    try { var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return !!r && r !== 'main'; }
    catch (e) { return false; }
  }
  var PRUEBA = {};
  (function cargarPrueba() {
    if (!enPreview()) return;
    try {
      PRUEBA = JSON.parse(sessionStorage.getItem('epCyPrueba') || '{}');
      var q = new URLSearchParams(location.search);
      if (q.get('cyber_prueba') === 'off') PRUEBA = {};
      ['ahora', 'regalo', 'd5', 'mp', 'sabores'].forEach(function (k) {
        var v = q.get('cyber_' + k);
        if (v !== null) PRUEBA[k] = v;
      });
      sessionStorage.setItem('epCyPrueba', JSON.stringify(PRUEBA));
    } catch (e) { PRUEBA = {}; }
  })();

  function ahora() {
    if (PRUEBA.ahora) {
      var s = PRUEBA.ahora.length <= 16 ? PRUEBA.ahora + ':00-03:00' : PRUEBA.ahora;
      var t = Date.parse(s);
      if (!isNaN(t)) return t + (Date.now() - CARGA);
    }
    return Date.now();
  }
  var CARGA = Date.now();

  function bool(v, base) { return v === undefined ? base : (v === '1' || v === 'true'); }

  // ── El estado de la oferta ──────────────────────────────────────────────────
  function estado() {
    var t = ahora();
    var etapa = t < T.inicio ? 'antes' : t < T.nucleo ? 'pre' : t < T.post ? 'nucleo' : t < T.fin ? 'post' : 'fin';
    var vigente = !!CFG.activo && (etapa === 'pre' || etapa === 'nucleo' || etapa === 'post');
    var sabores = SABORES.filter(function (s) {
      if (PRUEBA.sabores) return PRUEBA.sabores === 'todos' || PRUEBA.sabores.split(',').indexOf(s.key) !== -1;
      return !!(CFG.sabores && CFG.sabores[s.key]);
    }).map(function (s) { return s.nombre; });
    var regalo = vigente && bool(PRUEBA.regalo, !!CFG.regalo) && sabores.length > 0;
    var d5 = vigente && bool(PRUEBA.d5, !!CFG.d5);
    var mp = vigente && etapa !== 'pre' && bool(PRUEBA.mp, !!CFG.mp);
    // Mercado Pago todavía no se pinta: su jerarquía en el ticket se aprueba antes del lun 5 (Tomi, 30-sep).
    var mpVisible = mp && !!CFG.mpListo;
    var on = vigente && (regalo || d5 || mpVisible);
    var cuenta = etapa === 'nucleo' ? { fin: T.post - 1000, l: 'El Cyber termina en' }
      : etapa === 'post' ? { fin: T.fin - 1000, l: 'Últimos días, terminan en' }
      : { fin: T.fin - 1000, l: 'Termina en' };
    return {
      etapa: etapa, on: on, regalo: regalo && on, d5: d5 && on, mp: mpVisible && on,
      sabores: sabores, cuenta: cuenta,
      // Sin fechas en la web mientras dura la oferta; la fecha entra al final, como urgencia (Tomi, 1-oct).
      hasta: t < T.urgDia || etapa === 'fin' ? ''
        : t < T.post ? 'Último día'
        : t < T.urgAlarga ? (regalo && on ? 'Últimos regalos' : 'Últimos días')
        : 'Lo alargamos: solo hasta el domingo',
    };
  }

  // ── Piezas ──────────────────────────────────────────────────────────────────
  function c(k, v, s) {
    return '<div class="epcy-tk__c">' + (k ? '<div class="epcy-tk__k">' + k + '</div>' : '')
      + '<div class="epcy-tk__v">' + v + '</div>' + (s ? '<div class="epcy-tk__s">' + s + '</div>' : '') + '</div>';
  }

  // El beneficio principal: el regalo, o los $5.000 cuando ya no hay regalo.
  function piezas(e, o) {
    var p = [];
    if (e.regalo) p.push(c(o.kRegalo, '🎁 Barritas de regalo', o.grande ? 'Una Caja 5, se agrega sola al carro' : ''));
    if (e.d5) p.push(c(e.regalo ? (o.grande ? 'Además, en tu pack' : 'Además') : o.kD5, '$5.000 de descuento', o.grande ? 'Se aplica solo en el carro' : ''));
    return p;
  }

  function ticket(e, o) {
    var p = piezas(e, o);
    if (!p.length) return '';
    var cls = 'epcy-tk' + (o.grande ? '' : ' epcy-tk--chico') + (o.beige ? ' epcy-tk--beige' : '')
      + (p.length > 1 ? ' epcy-tk--doble' : ' epcy-tk--solo');
    return '<div class="' + cls + '">' + p.join(PLUS) + '</div>';
  }

  // El código del cupón de Mercado Pago, siempre igual en toda la web (Tomi, 5-oct: que se entienda fácil cuál es).
  function cod(t) { return '<span class="epcy-cod' + (t ? ' epcy-cod--' + t : '') + '">CYBERMP</span>'; }
  function mpLinea() {
    return '<div class="epcy-tkmp"><img src="' + CFG.mpLogo + '" alt="Mercado Pago" width="62" height="16">'
      + '<span><b>+ $5.000</b> pagando con Mercado Pago · código ' + cod('sm') + '</span></div>';
  }

  function textoBarra(e) {
    if (e.regalo && e.d5) return '🎁 Barritas de regalo + $5.000 de descuento';
    if (e.regalo) return '🎁 Barritas de regalo en tu Pack 40, 60 u 80';
    if (e.d5) return '$5.000 de descuento en tu Pack 40, 60 u 80';
    return '';
  }

  // Urgencia del día como sticker amarillo inclinado (opción A de Tomi, 7-oct; output/prototipos/cyber-oct26/urgencia-estilo/).
  // "Lo alargamos: solo hasta el domingo" va separado: lo de antes de los dos puntos, chico y en verde arriba (Tomi, 7-oct).
  function urgSpan(e) {
    var p = e.hasta.split(': '), k = p.length > 1 ? p[0] : '', v = p.length > 1 ? p.slice(1).join(': ') : e.hasta;
    return '<span class="epcy-urg' + (k ? ' epcy-urg--k' : '') + (v.length > 22 ? ' epcy-urg--largo' : '') + '">'
      + (k ? '<span class="epcy-urg__k">' + k + '</span>' : '') + v + '</span>';
  }
  function urgHtml(e) { return e.hasta ? '<div class="epcy-urg-w">' + urgSpan(e) + '</div>' : ''; }

  function cuentaHtml(e) {
    return '<div class="epcy-cd"><div class="epcy-cd__l">' + e.cuenta.l + '</div><div class="epcy-cd__p">'
      + '<div><b data-cd="d"></b><small>días</small></div><div><b data-cd="h"></b><small>horas</small></div>'
      + '<div><b data-cd="m"></b><small>min</small></div><div><b data-cd="s"></b><small>seg</small></div></div></div>';
  }

  var PINTA = {
    barra: function (el, e) {
      el.innerHTML = '<a href="' + PACKS_URL + '">Cyber EasyProtein<i>•</i>' + textoBarra(e)
        + (e.mp ? '<span class="epcy-barra__mp"><i>•</i>+ $5.000 con Mercado Pago: código <b>CYBERMP</b></span>' : '')
        + (e.hasta ? '<span class="epcy-barra__fin"><i>•</i>' + e.hasta + '</span>' : '') + '</a>';
    },
    hero: function (el, e) {
      var d = el.dataset;
      el.innerHTML = '<div class="epcy-hero__ey">Cyber EasyProtein' + (e.hasta ? ' · ' + e.hasta : '') + '</div>'
        + ticket(e, { grande: true, kRegalo: 'En tu Pack 40, 60 u 80', kD5: 'En tu Pack 40, 60 u 80' })
        + '<div class="epcy-hero__acts"><a class="epcy-pill" href="' + (d.url || PACKS_URL) + '">' + (d.boton || 'Quiero mi pack') + '</a>'
        + cuentaHtml(e)
        + '<a class="epcy-bases" href="' + (CFG.bases || '/pages/bases-cyber') + '">Bases de la promoción</a></div>'
        + (d.foto ? '<div class="epcy-hero__foto"><img src="' + d.foto + '" alt="" loading="eager"></div>' : '');
    },
    ticket: function (el, e) {
      var d = el.dataset;
      var html = ticket(e, { kRegalo: d.kRegalo || 'Con tu pack', kD5: d.kD5 || d.kRegalo || 'Con tu pack', beige: d.beige === '1' });
      // Bajo el ticket del regalo, una línea chica con el cupón de Mercado Pago y su código.
      if (html && e.mp) html += mpLinea();
      if (html && d.linkUrl) html += '<a class="epcy-link" href="' + d.linkUrl + '">' + (d.linkTxt || 'Ver los packs →') + '</a>';
      if (html) html = urgHtml(e) + html;
      el.innerHTML = html;
      el.hidden = !html;
    },
    // El sticker de urgencia solo, sobre la tarjeta del Cyber del hero de la portada.
    urg: function (el, e) {
      el.innerHTML = e.hasta ? urgSpan(e) : '';
      el.hidden = !e.hasta;
    },
    // Cupón de Mercado Pago bajo los packs de la portada (opción A, Tomi, 4-oct): ticket con el logo en el
    // talón. Va aparte del regalo y más chico; solo mientras haya cupones (interruptor cy_mp).
    mpban: function (el, e) {
      if (!e.mp) { el.hidden = true; return; }
      el.innerHTML = '<div class="epcy-mpb"><div class="epcy-mpb__tal"><img src="' + CFG.mpLogo + '" alt="Mercado Pago"></div>'
        + '<div class="epcy-mpb__cu"><div class="epcy-mpb__k">Además, en este Cyber</div>'
        + '<div class="epcy-mpb__v">$5.000 de descuento</div>'
        + '<div class="epcy-mpb__s">Pagando con dinero en tu cuenta Mercado Pago</div>'
        + '<div class="epcy-mpb__cod"><span>Usa el código</span>' + cod('lg') + '</div>'
        + '<div class="epcy-mpb__acts"><a class="epcy-mpb__btn" href="' + (CFG.mpUrl || '/pages/cupon-cybermp') + '">¿Cómo se usa? →</a>'
        + '<span class="epcy-mpb__leg">Hasta agotar cupones · Promoción de Mercado Pago</span></div></div></div>';
    },
    mq: function (el, e) {
      var items = e.hasta ? [e.hasta, 'Cyber EasyProtein'] : ['Cyber EasyProtein'];
      if (e.regalo) items.push('🎁 Barritas de regalo desde el Pack 40');
      if (e.d5) items.push('$5.000 de descuento desde el Pack 40');
      if (e.mp) items.push('+ $5.000 con Mercado Pago · código CYBERMP');
      items.push('Envío gratis en todos los packs');
      var una = items.map(function (t) { return '<span class="ep-proof__item">' + t + '<span class="ep-proof__sep"></span></span>'; }).join('');
      el.innerHTML = una + una + una + una;
    },
  };

  function cumple(cond, e) {
    var neg = cond.charAt(0) === '!';
    var k = neg ? cond.slice(1) : cond;
    var v = k === 'on' ? e.on : k === 'off' ? !e.on : !!e[k];
    return neg ? !v : v;
  }

  function render(root) {
    var e = estado();
    root = root || document;
    var de = document.documentElement;
    de.classList.toggle('epcy-on', e.on);
    de.classList.toggle('epcy-regalo', e.regalo);
    root.querySelectorAll('[data-cy]').forEach(function (el) {
      el.hidden = !el.getAttribute('data-cy').split(' ').every(function (cnd) { return cumple(cnd, e); });
    });
    root.querySelectorAll('[data-cy-comp]').forEach(function (el) {
      var f = PINTA[el.getAttribute('data-cy-comp')];
      if (!f) return;
      if (!e.on) { el.hidden = true; return; }
      el.hidden = false;
      f(el, e);
    });
    tick();
    return e;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var e = ULTIMO || estado();
    var s = Math.max(0, Math.floor((e.cuenta.fin - ahora()) / 1000));
    var v = { d: Math.floor(s / 86400), h: pad(Math.floor(s % 86400 / 3600)), m: pad(Math.floor(s % 3600 / 60)), s: pad(s % 60) };
    document.querySelectorAll('[data-cd]').forEach(function (el) { el.textContent = v[el.getAttribute('data-cd')]; });
  }

  var ULTIMO = null;
  function firma(e) { return [e.etapa, e.on, e.regalo, e.d5, e.mp, e.sabores.join('|'), e.hasta].join(','); }

  window.EpCyber = {
    estado: estado,
    render: function (root) { ULTIMO = render(root); return ULTIMO; },
    sabores: SABORES,
    enPreview: enPreview,
  };

  // Primera pasada apenas existe el DOM; luego cada segundo la cuenta, y si cambia el tramo se repinta
  // todo y se avisa (el regalo del carro escucha 'epcyber:cambio').
  function arrancar() {
    ULTIMO = render();
    setInterval(function () {
      var e = estado();
      if (firma(e) !== firma(ULTIMO)) {
        ULTIMO = render();
        document.dispatchEvent(new CustomEvent('epcyber:cambio', { detail: ULTIMO }));
      } else { tick(); }
    }, 1000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
})();
